import {Component, Input, OnInit} from '@angular/core';
import {SearchService} from './search.service';
import {Observable, Subject} from 'rxjs';
import {ControlContainer, NgForm} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';

export interface SearchData {
    name: string;
}

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    providers: [SearchService],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class SearchComponent implements OnInit {

    @Input() data: SearchData[] = [];
    @Input() placeholder: string;

  searchTerm$ = new Subject<string>();
  results:              object;   // TODO: NR - should be observable
  resultsPanel:         boolean = false;
  query:                string = '';

    /* TODO (NR): Use service, when integration data is done */
    // constructor(private provider: SearchService) {
    //   this.provider
    //       .search(this.searchTerm$)
    //       .subscribe(results => {
    //         this.results = results;
    //       });
    // }

    constructor() {
    }

    ngOnInit() {
        this.search(this.searchTerm$)
            .subscribe(results => {
                this.results = results;
            });
    }

    search(terms: Observable<string>) {
        return terms.pipe(
            startWith(''),
            map(term => this.searchEntries(term))
        );
    }

    searchEntries(term) {
        const filterValue = term.toLowerCase();
        return this.data.filter(item => item.name.toLowerCase().includes(filterValue));
    }


    show(event) {
        this.resultsPanel = true;
    }

    hide(event) {
        this.resultsPanel = false;
    }

    // TODO: NR - to eliminate show/hide functions
    handleBlur() {

    }

    select(event, item) {
        event.stopPropagation();
        this.query = item.name;
    }
}
